global.quietmark.inView('.js-t-done-scroll').on('enter', (item) => {
    item.classList.add('t-done');
});
